<template>
  <div class="container">
    <div class="field">
      <label class="label">{{ $t("name") }}</label>
      <input type="text" class="input" v-model="name" />
    </div>
    <div class="field">
      <label class="label">{{ $t("code") }}</label>
      <div class="tabs is-toggle is-fullwidth" ref="tabs">
        <ul>
          <li
            class="is-active"
            data-tab="html"
            @click="change_active_tab($event, this)"
          >
            <a>
              <i class="html5 icon" aria-hidden="true"></i>
              <span>{{ $t("html") }}</span>
            </a>
          </li>
          <li data-tab="javascript" @click="change_active_tab($event, this)">
            <a>
              <i class="js icon" aria-hidden="true"></i>
              <span>{{ $t("javascript") }}</span>
            </a>
          </li>
          <li data-tab="css" @click="change_active_tab($event, this)">
            <a>
              <i class="css3 icon" aria-hidden="true"></i>
              <span>{{ $t("css") }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="container is-fluid" ref="contents">
        <div class="" data-tab="html">
          <vue-monaco-editor
            v-model:value="code.html"
            theme="vs-dark"
            language="html"
            :options="{
              automaticLayout: true,
              formatOnType: true,
              formatOnPaste: true,
              tabSize: 2,
              scrollBeyondLastLine: false,
              folding: true,
              bracketPairColorization: true,
              autoClosingBrackets: 'always',
              autoIndent: 'full',
            }"
            style="height: 500px"
          />
        </div>
        <div class="is-hidden" data-tab="javascript">
          <vue-monaco-editor
            v-model:value="code.js"
            theme="vs-dark"
            language="javascript"
            :options="{
              automaticLayout: true,
              formatOnType: true,
              formatOnPaste: true,
              tabSize: 2,
              scrollBeyondLastLine: false,
              folding: true,
              bracketPairColorization: true,
              autoClosingBrackets: 'always',
              autoIndent: 'full',
            }"
            style="height: 500px"
          />
          <article class="message is-info mt-5">
            <div class="message-body">
              <div class="title is-5">{{ $t("hints") }}</div>
              <div class="content">
                <ul>
                  <li
                    v-html="
                      $t(
                        `use this.emitter.emit('submit', payload_object) to send an outcome`
                      )
                    "
                  ></li>
                  <li>
                    {{ $t("expected payload_object structure") }}
                    <pre>{{
                      JSON.stringify(
                        { outcome: "OUTCOME", payload: {} },
                        null,
                        2
                      )
                    }}</pre>
                  </li>
                </ul>
              </div>
            </div>
          </article>
        </div>
        <div class="is-hidden" data-tab="css">
          <vue-monaco-editor
            v-model:value="code.css"
            theme="vs-dark"
            language="css"
            :options="{
              automaticLayout: true,
              formatOnType: true,
              formatOnPaste: true,
              tabSize: 2,
              scrollBeyondLastLine: false,
              folding: true,
              bracketPairColorization: true,
              autoClosingBrackets: 'always',
              autoIndent: 'full',
            }"
            style="height: 500px"
          />
        </div>
      </div>
      <!-- <div class="control">
        <div ref="editor_wrapper"></div>
        <textarea ref="editor" class="textarea" v-model="code"></textarea>
      </div> -->
    </div>
    <!-- <div class="buttons">
      <button
        class="button is-primary is-rounded"
        :disabled="!human_task"
        @click="save"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
    </div> -->
  </div>
</template>

<script>
import {
  del,
  put,
  get,
  error_message,
  success_message,
  change_active_tab,
} from "@/utils";
import { VueMonacoEditor } from "@guolao/vue-monaco-editor";

export default {
  data() {
    return {
      editor: null,
      human_task: undefined,
      code: {
        html: "",
        js: "",
        css: "",
      },
      name: "",
    };
  },
  components: {
    VueMonacoEditor,
  },
  mounted() {},
  methods: {
    change_active_tab,
    init() {},
    save() {
      let v = this;
      // const code = this.editor.getValue();
      v.$root.loader(true);
      put("/ngine/composer/human-task/code", {
        uuid: v.human_task.uuid,
        code: v.code,
        name: v.name,
      })
        .then((response) => {
          success_message(v.$t("code updated"));
          v.$emit("success");
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    edit(uuid) {
      let v = this;
      // if (!v.editor) v.init();
      // v.editor.setValue("");
      v.code = {
        html: "",
        js: "",
        css: "",
      };
      v.$root.loader(true);
      get("/ngine/composer/human-task", { uuid: uuid })
        .then((response) => {
          v.human_task = response;
          if (
            v.human_task &&
            v.human_task.settings &&
            v.human_task.settings.code
          ) {
            // v.code = v.human_task.settings.code;
            if (typeof v.human_task.settings.code === "string")
              v.code.html = v.human_task.settings.code;
            else v.code = v.human_task.settings.code;
          }

          if (v.human_task && v.human_task.name) v.name = v.human_task.name;

          try {
          } catch (error) {
            console.error(error);
          }
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    clear() {
      this.human_task = undefined;
      this.code = {
        html: "",
        js: "",
        css: "",
      };
      this.name = "";
    },
    get_data() {
      return {
        code: this.code,
        name: this.name,
      };
    },
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}
.textarea {
  height: 300px;
}
.buttons {
  margin-top: 10px;
}
</style>
